import {
  ANALYTICS_ENTRY_HANDOFF_PARAM,
  classifyEntryAttribution,
  type EntryAttribution,
  type EntryAttributionInput,
} from '@omaplus/shared-analytics-attribution';

export type BrowserSourceInput = EntryAttributionInput;
export type BrowserAttribution = EntryAttribution;

/** Browser-compatible façade; shared code owns the actual entry classifier. */
export function classifyBrowserAttribution(input: BrowserSourceInput): BrowserAttribution {
  return classifyEntryAttribution(input);
}

/**
 * Returns the browser search string with every login-return marker removed.
 * It is pure so callers can defer history mutation until after React commits.
 */
export function withoutBrowserEntryHandoff(search: string): string | null {
  const query = new URLSearchParams(search);
  if (!query.has(ANALYTICS_ENTRY_HANDOFF_PARAM)) {
    return null;
  }
  query.delete(ANALYTICS_ENTRY_HANDOFF_PARAM);
  const remaining = query.toString();
  return remaining === '' ? '' : `?${remaining}`;
}
